module.exports = __webpack_public_path__ + "img/pic_3.26eed306.png";